export default {
  buttons: { done: 'Klaar' },
  title: 'Locatie',
};
